/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_CancelInputs */

const id_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const ms_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const da_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller`)
};

const de_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const en_us2_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const es_es2_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const es_mx2_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fil_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanselahin`)
};

const fr_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const it_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const hu_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mégse`)
};

const nl_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleren`)
};

const no_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt`)
};

const pl_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj`)
};

const pt_br2_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const pt_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const ro_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulare`)
};

const fi_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta`)
};

const sv_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt`)
};

const vi_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

const tr_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal`)
};

const cs_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const bg_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отказ`)
};

const ru_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const uk_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати`)
};

const ar_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إلغاء`)
};

const hi_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करें`)
};

const th_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const ja_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

const zh_cn2_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const zh_hant1_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const ko_forms_review_cancel = /** @type {(inputs: Forms_Review_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Forms_Review_CancelInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_cancel = /** @type {((inputs?: Forms_Review_CancelInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_CancelInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_cancel(inputs)
	if (locale === "ms") return ms_forms_review_cancel(inputs)
	if (locale === "da") return da_forms_review_cancel(inputs)
	if (locale === "de") return de_forms_review_cancel(inputs)
	if (locale === "en-US") return en_us2_forms_review_cancel(inputs)
	if (locale === "es-ES") return es_es2_forms_review_cancel(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_cancel(inputs)
	if (locale === "fil") return fil_forms_review_cancel(inputs)
	if (locale === "fr") return fr_forms_review_cancel(inputs)
	if (locale === "it") return it_forms_review_cancel(inputs)
	if (locale === "hu") return hu_forms_review_cancel(inputs)
	if (locale === "nl") return nl_forms_review_cancel(inputs)
	if (locale === "no") return no_forms_review_cancel(inputs)
	if (locale === "pl") return pl_forms_review_cancel(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_cancel(inputs)
	if (locale === "pt") return pt_forms_review_cancel(inputs)
	if (locale === "ro") return ro_forms_review_cancel(inputs)
	if (locale === "fi") return fi_forms_review_cancel(inputs)
	if (locale === "sv") return sv_forms_review_cancel(inputs)
	if (locale === "vi") return vi_forms_review_cancel(inputs)
	if (locale === "tr") return tr_forms_review_cancel(inputs)
	if (locale === "cs") return cs_forms_review_cancel(inputs)
	if (locale === "bg") return bg_forms_review_cancel(inputs)
	if (locale === "ru") return ru_forms_review_cancel(inputs)
	if (locale === "uk") return uk_forms_review_cancel(inputs)
	if (locale === "ar") return ar_forms_review_cancel(inputs)
	if (locale === "hi") return hi_forms_review_cancel(inputs)
	if (locale === "th") return th_forms_review_cancel(inputs)
	if (locale === "ja") return ja_forms_review_cancel(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_cancel(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_cancel(inputs)
	return ko_forms_review_cancel(inputs)
});
export { forms_review_cancel as "forms.review.cancel" }